import { Link2Off } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { Association } from '@/pages/StaffSignInPage'

export default function SignInLinkUnavailablePage({ association }: { association: Association }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border bg-card">
        <div className="mx-auto flex h-16 max-w-3xl items-center gap-3 px-6">
          <span
            aria-hidden="true"
            className="flex size-8 shrink-0 items-center justify-center rounded-md bg-primary text-body-sm font-semibold text-primary-foreground"
          >
            {association.name.slice(0, 1)}
          </span>
          <span className="truncate text-body-sm font-medium">{association.name}</span>
        </div>
      </header>
      <main className="mx-auto flex max-w-md flex-col items-center px-6 pt-[22vh] text-center">
        <span className="flex size-12 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Link2Off className="size-6" strokeWidth={1.5} aria-hidden="true" />
        </span>
        <h1 className="mt-4 text-subheading font-semibold">This sign-in link is not available</h1>
        <p className="mt-2 text-body-sm text-muted-foreground">
          Ask your association to check the sign-in link.
        </p>
        <Button asChild className="mt-6 h-9">
          <a href="/portal">Go to your portal</a>
        </Button>
      </main>
    </div>
  )
}
